export const ERROR_MESSAGE = {
  agency_exist: {
    header: 'Agency Already Exist',
    message: 'Please select another agency',
  },
  agency_code: {
    header: 'Invalid Access Code',
    message: 'Please contact your agency for their security code, in order to add them as a representative.',
  },
  division_exist: {
    header: 'Divison Already Exist',
    message: 'Select another division.',
  },
  unprocessable_entity: {
    header: 'Unprocessable Entity is Detected',
    message: 'Contact support to address this.',
  },
  general: {
    header: 'Something went wrong',
    message: `Your request can't be processed for now, please try again later.`,
  },
};
